import { SVGProps } from 'react';

const Like = ({ props, size = 24 }: { props?: SVGProps<SVGSVGElement>; size?: string | number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 19 18" fill="none" {...props}>
    <path
      stroke="#39D08F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M4.75 7.75v8a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3Zm0 0a4 4 0 0 0 4-4v-1a2 2 0 1 1 4 0v5h3a2 2 0 0 1 2 2l-1 5c-.144.614-.417 1.14-.777 1.501-.361.36-.79.536-1.223.499h-7a3 3 0 0 1-3-3"
    />
  </svg>
);

export default Like;
